export const surface = "white/black.1500";
export const surfaceBright = "white/black.1300";
export const surfaceContainer = "white/black.1100";
export const surfaceContainerVariant = "navy.100/black.300";
export const surfaceContainerHigh = "navy.100/black.300";
export const surfaceContainerHighest = "navy.400/black.800";
export const outline = "navy.200/black.500";
export const outlineVariant = "navy.300/grey.1200";
export const onSurface = "navy.1100/grey.100";
export const onSurfaceVariant = "navy.700/grey.400";
export const onSurfaceContainerVariant = "grey.600/grey.1000";
export const disabled = "navy_alpha.8/grey_alpha.20";
export const onSurfaceDisabled = "navy_alpha.40/grey_alpha.45";
export const primary = "purple.900/purple.600";
export const onPrimary = "white/purple.1900";
export const primaryContainer = "purple.200/purple.1700";
export const onPrimaryContainer = "purple.1100/purple.100";
export const secondary = "violet.1000/violet.500";
export const onSecondary = "white/violet.2000";
export const secondaryContainer = "violet.150/violet.1700";
export const onSecondaryContainer = "violet.1900/violet.100";
export const onSecondaryContainerVariant = "violet.1400/violet.400";
export const tertiary = "blue.1100/blue.600";
export const onTertiary = "white/blue.2000";
export const outlineTertiary = "blue.1000/blue.900";
export const tertiaryContainer = "blue.150/blue.1700";
export const onTertiaryContainer = "blue.1800/blue.150";
export const onTertiaryContainerVariant = "blue.1200/blue.500";
export const success = "green.1200/green.500";
export const onSuccess = "white/green.2000";
export const successContainer = "green.150/green.1700";
export const onSuccessContainer = "green.1800/green.150";
export const error = "red.1100/red.600";
export const onError = "white/red.2000";
export const errorContainer = "red.150/red.1700";
export const onErrorContainer = "red.1800/red.100";
export const warning = "yellow.600/yellow.600";
export const onWarning = "yellow.1700/yellow.1900";
export const warningContainer = "yellow.150/yellow.1700";
export const onWarningContainer = "yellow.1700/yellow.150";
export const neutral = "navy.1100/grey.200";
export const onNeutral = "white/black.1600";
export const connect = "purple.900/purple.600";
export const onConnect = "white/purple.1900";
export const keyExchange = "violet.1000/violet.600";
export const onKeyExchange = "white/violet.1900";
export const seasonLowest = "green.400/green.1600";
export const onSeasonLowest = "green.2000/white";
export const seasonMedium = "green.800/green.1200";
export const onSeasonMedium = "green.2000/white";
export const seasonHigh = "green.1200/green.800";
export const onSeasonHigh = "white/green.2000";
export const seasonHighest = "green.1600/green.400";
export const onSeasonHighest = "white/green.2000";
export const business = "plum.1400/plum.1500";
export const businessVariant = "plum.1100/plum.900";
export const onBusiness = "white/white";
export const onBusinessVariant = "lime.400/lime.400";
export const businessContainer = "lime.200/lime.200";
export const onBusinessContainer = "plum.1600/plum.1300";
export const hover = "black_alpha.4/white_alpha.15";
export const focus = "black_alpha.8/white_alpha.20";
export const press = "black_alpha.8/white_alpha.20";
export const drag = "black_alpha.16/white_alpha.20";
export const scrim = "black_alpha.16/black_alpha.26";
export const surfaceFixed = "white/grey.200";
export const onSurfaceFixed = "navy.1100/navy.1100";
export const inverseSurface = "navy.1100/navy.1100";
export const inverseOnSurface = "white/grey.100";
export const marketingContainer = "lime.150/lime.1700";
export const onMarketingContainer = "lime.1600/lime.150";
export const surfaceBrand = "purple.900/purple.1100";
export const onSurfaceBrand = "white/white";
export default {
  "surface": "white/black.1500",
  "surfaceBright": "white/black.1300",
  "surfaceContainer": "white/black.1100",
  "surfaceContainerVariant": "navy.100/black.300",
  "surfaceContainerHigh": "navy.100/black.300",
  "surfaceContainerHighest": "navy.400/black.800",
  "outline": "navy.200/black.500",
  "outlineVariant": "navy.300/grey.1200",
  "onSurface": "navy.1100/grey.100",
  "onSurfaceVariant": "navy.700/grey.400",
  "onSurfaceContainerVariant": "grey.600/grey.1000",
  "disabled": "navy_alpha.8/grey_alpha.20",
  "onSurfaceDisabled": "navy_alpha.40/grey_alpha.45",
  "primary": "purple.900/purple.600",
  "onPrimary": "white/purple.1900",
  "primaryContainer": "purple.200/purple.1700",
  "onPrimaryContainer": "purple.1100/purple.100",
  "secondary": "violet.1000/violet.500",
  "onSecondary": "white/violet.2000",
  "secondaryContainer": "violet.150/violet.1700",
  "onSecondaryContainer": "violet.1900/violet.100",
  "onSecondaryContainerVariant": "violet.1400/violet.400",
  "tertiary": "blue.1100/blue.600",
  "onTertiary": "white/blue.2000",
  "outlineTertiary": "blue.1000/blue.900",
  "tertiaryContainer": "blue.150/blue.1700",
  "onTertiaryContainer": "blue.1800/blue.150",
  "onTertiaryContainerVariant": "blue.1200/blue.500",
  "success": "green.1200/green.500",
  "onSuccess": "white/green.2000",
  "successContainer": "green.150/green.1700",
  "onSuccessContainer": "green.1800/green.150",
  "error": "red.1100/red.600",
  "onError": "white/red.2000",
  "errorContainer": "red.150/red.1700",
  "onErrorContainer": "red.1800/red.100",
  "warning": "yellow.600/yellow.600",
  "onWarning": "yellow.1700/yellow.1900",
  "warningContainer": "yellow.150/yellow.1700",
  "onWarningContainer": "yellow.1700/yellow.150",
  "neutral": "navy.1100/grey.200",
  "onNeutral": "white/black.1600",
  "connect": "purple.900/purple.600",
  "onConnect": "white/purple.1900",
  "keyExchange": "violet.1000/violet.600",
  "onKeyExchange": "white/violet.1900",
  "seasonLowest": "green.400/green.1600",
  "onSeasonLowest": "green.2000/white",
  "seasonMedium": "green.800/green.1200",
  "onSeasonMedium": "green.2000/white",
  "seasonHigh": "green.1200/green.800",
  "onSeasonHigh": "white/green.2000",
  "seasonHighest": "green.1600/green.400",
  "onSeasonHighest": "white/green.2000",
  "business": "plum.1400/plum.1500",
  "businessVariant": "plum.1100/plum.900",
  "onBusiness": "white/white",
  "onBusinessVariant": "lime.400/lime.400",
  "businessContainer": "lime.200/lime.200",
  "onBusinessContainer": "plum.1600/plum.1300",
  "hover": "black_alpha.4/white_alpha.15",
  "focus": "black_alpha.8/white_alpha.20",
  "press": "black_alpha.8/white_alpha.20",
  "drag": "black_alpha.16/white_alpha.20",
  "scrim": "black_alpha.16/black_alpha.26",
  "surfaceFixed": "white/grey.200",
  "onSurfaceFixed": "navy.1100/navy.1100",
  "inverseSurface": "navy.1100/navy.1100",
  "inverseOnSurface": "white/grey.100",
  "marketingContainer": "lime.150/lime.1700",
  "onMarketingContainer": "lime.1600/lime.150",
  "surfaceBrand": "purple.900/purple.1100",
  "onSurfaceBrand": "white/white"
}
;